module.exports = __webpack_public_path__ + "img/general-meter-water-meter-hot-md.ed4bc27d.svg";